import forEach from '../lib/foreach'
import isMobile from '../lib/isMobile'
import imagesLoaded from 'imagesLoaded'

export default class Slideshow {
  constructor(el) {
    this.el = el
    this.items = []
    this.currentIndex = 0
    this.interval = 6 // seconds

    forEach(document.querySelectorAll('.hero-slideshow .slide'), item => {
      this.items.push({
        el: item,
        src: item.src
      })
    })

    setTimeout(() => {
      setInterval(this.rotate.bind(this), this.interval * 1000)
    }, 1000)
  }

  rotate() {
    this.hide(this.items[this.currentIndex])

    if (this.currentIndex >= this.items.length - 1) {
      this.currentIndex = 0
    } else {
      this.currentIndex += 1
    }

    this.show(this.items[this.currentIndex])
  }

  show(item) {
    item.el.classList.add('-active')
  }

  hide(item) {
    item.el.classList.remove('-active')
  }
}



// WEBPACK FOOTER //
// ./src/javascript/features/slideshow.js